module.exports = __webpack_public_path__ + "img/TOCTemp1.0a7c3d39.png";